export default "__VITE_ASSET__dc72a246__"